import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Card, Button, Row, Col, Form, FormControl, Modal, Spinner, Table, Pagination } from 'react-bootstrap';
import { FaDownload, FaSearch, FaEraser, FaFilePdf, FaFileInvoice } from 'react-icons/fa';
import api from '../../api/apiweb-buscadordocs.js';
import './Search.scss';
import obj from '../../api/apiweb-getpdf';
import Rut from 'rutjs';
import { tiposDisponiblesEmpresa, labelTipoDocumento, tieneReceptor } from '../../constants/tiposDocumento';
import { formatoMiles } from '../../utils/format';
import selectStyles from '../../utils/selectStyles';

const todosCajero = { label: 'Todos', value: '' };
const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];
const PAGE_SIZE_DEFAULT = 50;

function Search(props) {
  const [docType, setDocType] = useState('');
  const [folio, setFolio] = useState('');
  const [ticket, setTicket] = useState('');
  const [cajero, setCajero] = useState(todosCajero);
  const [startDate, setStartDate] = useState(new Date().toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [searching, setSearching] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [pageSize, setPageSize] = useState(PAGE_SIZE_DEFAULT);
  const [modalDescarga, setModalDescarga] = useState(false);
  const [mensajeFallo, setMensajeFallo] = useState(false);
  const [modalDescargaMensaje, setModalDescargaMensaje] = useState('');
  const [deviceOptions, setDevicesOptions] = useState([]);
  const __DEV__ = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [searchByHour, setSearchByHour] = useState(false);
  // Facturas y notas de crédito/débito llevan receptor: se puede filtrar y mostrar por él.
  const conReceptor = tieneReceptor(docType);
  const [rutReceptor, setRutReceptor] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [docTypeBuscado, setDocTypeBuscado] = useState(null);
  const [facturasPOS, setFacturasPOS] = useState(false);
  const conReceptorBuscado = tieneReceptor(docTypeBuscado);

  const tiposDocOpciones = tiposDisponiblesEmpresa(
    props.empresas,
    (t) => (t.codigo !== 33 && t.codigo !== 34) || facturasPOS,
    { incluirNotas: true },
  );
  const tipoUnico = tiposDocOpciones.length === 1 ? tiposDocOpciones[0].value : null;

  const columnasResultado = conReceptorBuscado
    ? [
      { key: 'folio', header: 'Folio' },
      { key: 'ticket', header: 'Ticket' },
      { key: 'tipodocumento', header: 'Tipo Documento' },
      { key: 'fechaemision', header: 'Fecha Emisión' },
      { key: 'receptorrut', header: 'RUT Receptor' },
      { key: 'receptorrazonsocial', header: 'Razón Social' },
      { key: 'valorneto', header: 'Valor Neto' },
      { key: 'valoriva', header: 'Valor IVA' },
      { key: 'valorexento', header: 'Valor Exento' },
      { key: 'valortotal', header: 'Valor Total' },
      { key: 'fechahora', header: 'Hora' },
      { key: 'descargar', header: 'Descargar' },
    ]
    : [
      { key: 'folio', header: 'Folio' },
      { key: 'ticket', header: 'Ticket' },
      { key: 'tipodocumento', header: 'Tipo Documento' },
      { key: 'fechaemision', header: 'Fecha Emisión' },
      { key: 'valorneto', header: 'Valor Neto' },
      { key: 'valoriva', header: 'Valor IVA' },
      { key: 'valorexento', header: 'Valor Exento' },
      { key: 'valortotal', header: 'Valor Total' },
      { key: 'fechahora', header: 'Hora' },
      { key: 'descargar', header: 'Descargar' },
    ];

  const searchDocument = async (rut, tipodocumento, folio, fechaEmision) => {
    setModalDescarga(true);
    setModalDescargaMensaje('Procesando');
    try {
      await obj.getPDF(rut, tipodocumento, folio, fechaEmision);
      setModalDescarga(false);
    } catch (error) {
      setModalDescargaMensaje('Error en la descarga');
      setMensajeFallo(true);
    }
  };

  const fechaValida = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s) && !Number.isNaN(new Date(s).getTime());

  // Devuelve un mensaje de error si las fechas no son válidas, o null si todo está bien.
  const validarFechas = () => {
    // Si se busca por folio, las fechas no son obligatorias. Solo se validan si se ingresan.
    const buscaPorFolio = folio.trim() !== '';

    if (buscaPorFolio) {
      if (startDate !== '' && !fechaValida(startDate)) {
        return searchByHour ? 'Debes ingresar una fecha válida' : 'Debes ingresar una fecha "Desde" válida';
      }
      if (!searchByHour) {
        if (endDate !== '' && !fechaValida(endDate)) {
          return 'Debes ingresar una fecha "Hasta" válida';
        }
        if (startDate !== '' && endDate !== '' && startDate > endDate) {
          return 'La fecha "Desde" debe ser menor o igual que la fecha "Hasta"';
        }
      }
      return null;
    }

    if (!fechaValida(startDate)) {
      return searchByHour ? 'Debes ingresar una fecha válida' : 'Debes ingresar una fecha "Desde" válida';
    }
    if (!searchByHour) {
      if (!fechaValida(endDate)) {
        return 'Debes ingresar una fecha "Hasta" válida';
      }
      if (startDate > endDate) {
        return 'La fecha "Desde" debe ser menor o igual que la fecha "Hasta"';
      }
    }
    return null;
  };

  const mostrarErrorFecha = (mensaje) => {
    setModalDescarga(true);
    setModalDescargaMensaje(mensaje);
    setMensajeFallo(true);
  };

  const busqueda = async (pagina = 1, tamano = pageSize) => {
    const errorFecha = validarFechas();
    if (errorFecha) {
      mostrarErrorFecha(errorFecha);
      return;
    }
    setSearching(true);
    setModalDescarga(true);
    setMensajeFallo(false);
    setModalDescargaMensaje('Procesando');

    let params;
    if (searchByHour) {
      if ((startTime !== '' && endTime === '') || (startTime === '' && endTime !== '')) {
        setModalDescargaMensaje('Intervalo de horas no válido');
        setMensajeFallo(true);
        setStartTime('');
        setEndTime('');
        setSearching(false);
        return;
      }
      params = { tipodocumento: docType, folio, ticket, startDate, endDate: startDate, device_id: cajero.value, startTime, endTime };
    } else {
      params = { tipodocumento: docType, folio, ticket, startDate, endDate, device_id: cajero.value };
    }

    if (conReceptor) {
      params.receptorrut = rutReceptor;
      params.receptorrazonsocial = razonSocial;
    }

    params.page = pagina;
    params.pageSize = tamano;

    api.getData(params).then(
      (data) => {
        setModalDescarga(false);
        if (__DEV__) { console.log(data); }
        const resp = data.data.records.map((record) => {
          if (record.fechahora != null) {
            record.fechahora = record.fechahora.split(' ')[1];
          }
          record.receptorrut = new Rut(record.receptorrut + '', true).getNiceRut();
          return {
            ...record,
            folio: formatoMiles(record.folio),
            tipodocumento: labelTipoDocumento(record.tipodocumento),
            valorneto: formatoMiles(record.valorneto),
            valoriva: formatoMiles(record.valoriva),
            valorexento: formatoMiles(record.valorexento),
            valortotal: formatoMiles(record.valortotal),
            descargar: (
              <Button
                size="sm"
                onClick={() => searchDocument(record.rut, record.tipodocumento, record.folio, record.fechaemision)}
                variant="outline-primary"
                title="Descargar PDF"
              >
                <FaFilePdf />
              </Button>
            ),
          };
        });
        setDocTypeBuscado(docType);
        setResponseData(resp);
        setPagination(data.data.pagination || null);
        setSearching(false);
      },
    ).catch(() => {
      setSearching(false);
      setModalDescargaMensaje('Error en la descarga');
      setMensajeFallo(true);
    });
  };

  const irPagina = (p) => {
    if (searching) return;
    if (p < 1 || (pagination && p > pagination.totalPages)) return;
    busqueda(p);
  };

  const cambiarTamano = (nuevoTamano) => {
    setPageSize(nuevoTamano);
    busqueda(1, nuevoTamano);
  };

  const descarga = () => {
    const errorFecha = validarFechas();
    if (errorFecha) {
      mostrarErrorFecha(errorFecha);
      return;
    }
    setModalDescarga(true);
    setMensajeFallo(false);
    setModalDescargaMensaje('Procesando');

    let params;
    if (searchByHour) {
      params = { tipodocumento: docType, folio, ticket, startDate, endDate: startDate, device_id: cajero.value, startHour: startTime, endHour: endTime, download: 'csv' };
    } else {
      params = { tipodocumento: docType, folio, ticket, startDate, endDate, device_id: cajero.value, download: 'csv' };
    }

    if (conReceptor) {
      params.receptorrut = rutReceptor;
      params.receptorrazonsocial = razonSocial;
    }

    api.download(params, (state, message) => {
      if (state) {
        setModalDescarga(false);
        setModalDescargaMensaje('');
        setDocTypeBuscado(docType);
      } else {
        if (message === 'Error en la descarga') {
          setModalDescargaMensaje(message);
          setMensajeFallo(true);
        } else {
          setModalDescargaMensaje(message);
        }
        setModalDescarga(true);
      }
    });
  };

  const limpiar = () => {
    setStartDate('');
    setEndDate('');
    setDocType(tipoUnico || '');
    setFolio('');
    setTicket('');
    setStartTime('');
    setEndTime('');
    setCajero(todosCajero);
    setRutReceptor('');
    setRazonSocial('');
    setResponseData(null);
    setPagination(null);
    setPageSize(PAGE_SIZE_DEFAULT);
  };

  const closeModal = () => {
    setModalDescarga(false);
  };

  useEffect(() => {
    const devices = props.devices;
    const array = [{ label: 'Todos', value: '' }];
    if (Array.isArray(devices)) {
      devices.forEach((element) => {
        array.push({ label: element.name, value: element.device_id });
      });
      setDevicesOptions(array);
    }
  }, [props.devices]);

  useEffect(() => {
    if (!conReceptor) {
      setRutReceptor('');
      setRazonSocial('');
    }
  }, [docType, conReceptor]);

  useEffect(() => {
    setFacturasPOS(props.facturasPOS);
  }, [props.facturasPOS]);

  useEffect(() => {
    if (tipoUnico) setDocType(tipoUnico);
  }, [tipoUnico]);

  return (
    <>
      <div className="Search">
        <div className="page-header">
          <h1 className="page-title">Búsqueda de Documentos</h1>
          <p className="page-subtitle">Consulta boletas, facturas y notas de crédito/débito electrónicas emitidas</p>
        </div>

        <Card className="search-card">
          <Card.Header className="search-card-header">
            <FaSearch className="me-2" />
            Filtros de búsqueda
          </Card.Header>
          <Card.Body>
            <Row className="g-3">
              <Col sm={12} md={6} lg={3}>
                <Form.Label htmlFor="docType">Tipo Documento</Form.Label>
                <Form.Select id="docType" value={docType} onChange={(e) => setDocType(e.target.value)}>
                  {tiposDocOpciones.length > 1 && <option value="">Todos</option>}
                  {tiposDocOpciones.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col sm={12} md={6} lg={3}>
                <Form.Label htmlFor="cajero">Cajero</Form.Label>
                <Select
                  inputId="cajero"
                  options={deviceOptions}
                  value={cajero}
                  onChange={(e) => setCajero(e)}
                  styles={selectStyles}
                />
              </Col>
              <Col sm={12} md={6} lg={3}>
                <Form.Label htmlFor="folio">Folio</Form.Label>
                <FormControl
                  id="folio"
                  value={folio}
                  inputMode="numeric"
                  onChange={(e) => setFolio(e.target.value.replace(/\D/g, ''))}
                />
              </Col>
              <Col sm={12} md={6} lg={3}>
                <Form.Label htmlFor="ticket">Ticket</Form.Label>
                <FormControl id="ticket" value={ticket} onChange={(e) => setTicket(e.target.value)} />
              </Col>

              <Col sm={6} md={3} lg={3}>
                <Form.Label htmlFor="startDate">{searchByHour ? 'Fecha' : 'Desde'}</Form.Label>
                <FormControl id="startDate" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </Col>
              {!searchByHour && (
                <Col sm={6} md={3} lg={3}>
                  <Form.Label htmlFor="endDate">Hasta</Form.Label>
                  <FormControl id="endDate" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </Col>
              )}
              {searchByHour && (
                <>
                  <Col sm={6} md={3} lg={3}>
                    <Form.Label htmlFor="startTime">Hora Inicio</Form.Label>
                    <FormControl id="startTime" type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                  </Col>
                  <Col sm={6} md={3} lg={3}>
                    <Form.Label htmlFor="endTime">Hora Fin</Form.Label>
                    <FormControl id="endTime" type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                  </Col>
                </>
              )}

              {conReceptor && (
                <>
                  <Col sm={12} md={6} lg={3}>
                    <Form.Label htmlFor="rutReceptor">RUT Receptor</Form.Label>
                    <FormControl
                      id="rutReceptor"
                      value={rutReceptor}
                      onChange={(e) => setRutReceptor(e.target.value)}
                      placeholder="Ej: 12345678-9"
                    />
                  </Col>
                  <Col sm={12} md={6} lg={3}>
                    <Form.Label htmlFor="razonSocial">Razón Social Receptor</Form.Label>
                    <FormControl
                      id="razonSocial"
                      value={razonSocial}
                      onChange={(e) => setRazonSocial(e.target.value)}
                      placeholder="Ej: Empresa S.A."
                    />
                  </Col>
                </>
              )}

              <Col xs={12}>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label="Buscar por hora"
                  checked={searchByHour}
                  onChange={(e) => setSearchByHour(e.target.checked)}
                />
              </Col>
            </Row>

            <div className="search-actions">
              <Button variant="primary" disabled={searching} onClick={() => busqueda(1)}>
                <FaSearch className="me-2" />Buscar
              </Button>
              <Button variant="success" onClick={descarga}>
                <FaDownload className="me-2" />Descargar CSV
              </Button>
              <Button variant="outline-secondary" onClick={limpiar} className="ms-auto">
                <FaEraser className="me-2" />Limpiar
              </Button>
            </div>
          </Card.Body>
        </Card>

        <Card className="search-card mt-4">
          <Card.Header className="search-card-header">
            <FaFileInvoice className="me-2" />
            Resultados
            {responseData && responseData.length > 0 && (
              <span className="results-count">{pagination ? pagination.total : responseData.length}</span>
            )}
          </Card.Header>
          <Card.Body>
            {responseData && responseData.length > 0 ? (
              <>
                <Table responsive hover className="results-table">
                  <thead>
                    <tr>
                      {columnasResultado.map((c) => (
                        <th key={c.key}>{c.header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {responseData.map((record, i) => (
                      <tr key={`${record.folio}-${record.ticket}-${i}`}>
                        {columnasResultado.map((c) => (
                          <td key={c.key}>{record[c.key]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {pagination && (
                  <div className="pagination-wrapper">
                    <div className="pagination-meta">
                      <span className="pagination-info">
                        Mostrando {(pagination.page - 1) * pagination.pageSize + 1}
                        {' - '}
                        {Math.min(pagination.page * pagination.pageSize, pagination.total)}
                        {' de '}{formatoMiles(pagination.total)}
                      </span>
                      <Form.Select
                        size="sm"
                        className="page-size-select"
                        value={pageSize}
                        disabled={searching}
                        onChange={(e) => cambiarTamano(Number(e.target.value))}
                      >
                        {PAGE_SIZE_OPTIONS.map((opt) => (
                          <option key={opt} value={opt}>{opt} por página</option>
                        ))}
                      </Form.Select>
                    </div>

                    {pagination.totalPages > 1 && (
                      <Pagination className="mb-0">
                        <Pagination.First disabled={pagination.page <= 1} onClick={() => irPagina(1)} />
                        <Pagination.Prev disabled={pagination.page <= 1} onClick={() => irPagina(pagination.page - 1)} />
                        {(() => {
                          const ventana = 2;
                          const inicio = Math.max(1, pagination.page - ventana);
                          const fin = Math.min(pagination.totalPages, pagination.page + ventana);
                          const items = [];
                          if (inicio > 1) { items.push(<Pagination.Ellipsis key="ini" disabled />); }
                          for (let p = inicio; p <= fin; p += 1) {
                            items.push(
                              <Pagination.Item key={p} active={p === pagination.page} onClick={() => irPagina(p)}>
                                {p}
                              </Pagination.Item>,
                            );
                          }
                          if (fin < pagination.totalPages) { items.push(<Pagination.Ellipsis key="fin" disabled />); }
                          return items;
                        })()}
                        <Pagination.Next disabled={pagination.page >= pagination.totalPages} onClick={() => irPagina(pagination.page + 1)} />
                        <Pagination.Last disabled={pagination.page >= pagination.totalPages} onClick={() => irPagina(pagination.totalPages)} />
                      </Pagination>
                    )}
                  </div>
                )}
              </>
            ) : (
              <div className="empty-state">
                <FaSearch className="empty-state-icon" />
                <p className="empty-state-text">
                  {responseData === null
                    ? 'Aplica filtros y presiona "Buscar" para ver resultados'
                    : 'No se encontraron documentos con los filtros aplicados'}
                </p>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>

      <Modal show={modalDescarga} onHide={closeModal} centered>
        <Modal.Header closeButton={mensajeFallo}>
          <Modal.Title>Búsqueda de documentos</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          {!mensajeFallo && <Spinner animation="border" variant="primary" className="mb-3" />}
          <div className="modal-message">{modalDescargaMensaje}</div>
        </Modal.Body>
        {mensajeFallo && (
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>Cerrar</Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}

export default Search;
